import { ProfileMapper } from '../../../../common/mappers/ProfileMapper';
import { InventoryMapper } from '../../../../common/inventory/mappers/InventoryMapper';
import { SeverityMapper } from '../../../../common/mappers/SeverityMapper';
import { DateUtils } from '../../../../common/utils/DateUtils';
import { ProjectPrintData } from '../models/ProjectPrintData';
import { Issue } from '../models/valueObjects/Issue';

export class ProjectPrintMapper {
  private readonly severityMapper = new SeverityMapper();
  private readonly inventoryMapper = new InventoryMapper();
  private readonly profileMapper = new ProfileMapper();

  mapGQLModel(data: any): ProjectPrintData {
    const lastAnalysis = data.lastAnalysis ? DateUtils.toMoment(data.lastAnalysis) : null;
    const defaultProfile = data.defaultProfile ? this.profileMapper.mapGQLModel(data.defaultProfile) : null;
    const inventory = this.inventoryMapper.mapGQLModel(data.inventory);
    const issues = this.mapIssues(data.vulnerabilities);

    return new ProjectPrintData(data.name, data.description ?? null, lastAnalysis, defaultProfile, issues, inventory, data.organization.name);
  }

  private mapIssues(issues: any): Issue[] | null {
    if (!issues || !issues.edges) return null;
    const issuesMap: { [key: number]: { number: number; title: string; shortExplanation: string; severity: string; numberOfSlots: number } } = {};
    for (const edge of issues.edges) {
      if (!issuesMap[edge.node.number]) {
        issuesMap[edge.node.number] = {
          number: edge.node.number,
          title: edge.node.title,
          shortExplanation: edge.node.shortExplanation,
          severity: edge.node.severity,
          numberOfSlots: 0,
        };
      }
      issuesMap[edge.node.number].numberOfSlots += edge.node.numberOfSlots;
    }
    return Object.values(issuesMap).map((i) => new Issue(i.number, i.title, i.shortExplanation, this.severityMapper.mapSeverity(i.severity), i.numberOfSlots));
  }
}
